import * as THREE from 'three';


class ThreeJSFunctions {



    // Uses the OBC OrthoPerspectiveCamera
    static centerCameraOnMesh(camera, mesh) {
        if (!camera || !mesh) {
            console.error("Invalid parameters passed to centerCameraOnMesh");
            return;
        }

        //fit is a OBC orthoperspectivecamera specific thing
        //takes an array of meshes and a double representing Zoom
        camera.fit([mesh], 0.1)


    }

    static SnapToViewCubeFace(cameraWrapper, controls, directionVector, targetObject = null) {
        const lookAtTarget = new THREE.Vector3(0, 0, 0);

        //console.log("TargetObject visible:", targetObject.visible);

        //console.log("camerawrapper sent to snap to face:", cameraWrapper)

        let safeDistance = 10;
        const isPerspective = cameraWrapper.projection.current === "Perspective";
        const camera = isPerspective ? cameraWrapper.threePersp : cameraWrapper.threeOrtho;

        if (targetObject) {
            const boundingBox = new THREE.Box3().setFromObject(targetObject);
            const size = new THREE.Vector3();
            const center = new THREE.Vector3();
            boundingBox.getSize(size);
            boundingBox.getCenter(center);
            lookAtTarget.copy(center);

            const maxSize = Math.max(size.x, size.y, size.z);
            if (isPerspective) {
                const fitHeightDistance = maxSize / (2 * Math.atan((Math.PI * camera.fov) / 360));
                const fitWidthDistance = fitHeightDistance / camera.aspect;
                safeDistance = 1.2 * Math.max(fitHeightDistance, fitWidthDistance);
            } else {
                safeDistance = maxSize * 1.2;
                camera.zoom = 10 / maxSize;
                camera.updateProjectionMatrix();
            }

            //console.log("Bounding box:", boundingBox);
            //console.log("Target size:", size);
            //console.log("Target center:", center);

        }

 
        const newPosition = lookAtTarget.clone().addScaledVector(
            directionVector.clone().normalize(),
            safeDistance
        );

        camera.position.copy(newPosition);
        const farPlane = Math.max(1000, safeDistance * 4);  // Don't let far clip too close
        camera.near = 0.1;
        camera.far = farPlane;
        camera.updateProjectionMatrix();

        //console.log("Camera newPosition:", newPosition);
        //console.log("Camera looking at:", lookAtTarget);
        //console.log("TargetObject visible 2:", targetObject.visible);

        if (controls?.setLookAt) {
            //console.log("setlookat", controls)
            controls.setLookAt(
                newPosition.x, newPosition.y, newPosition.z,
                lookAtTarget.x, lookAtTarget.y, lookAtTarget.z,
                true
            );
        } else if (controls?.target) {
            //console.log("set else", controls)
            controls.target.copy(lookAtTarget);
            controls.update?.();
        }
    }

    // static SnapToViewCubeFace(cameraWrapper, controls, directionVector, targetObject = null, fitOffset = 1.2) {
    //     console.log("Snapping to view cube face...");
    //     const lookAtTarget = new THREE.Vector3(0, 0, 0);
    //     let safeDistance = 10;

    //     if (targetObject) {
    //         const boundingBox = new THREE.Box3().setFromObject(targetObject);
    //         const size = new THREE.Vector3();
    //         const center = new THREE.Vector3();
    //         boundingBox.getSize(size);
    //         boundingBox.getCenter(center);
    //         lookAtTarget.copy(center);

    //         console.log("Bounding box size:", size);
    //         console.log("Bounding box center:", center);

    //         const maxSize = Math.max(size.x, size.y, size.z);
    //         const isPerspective = cameraWrapper.projection.current === "Perspective";
    //         const activeCamera = isPerspective ? cameraWrapper.threePersp : cameraWrapper.threeOrtho;

    //         if (isPerspective) {
    //             const fitHeightDistance = maxSize / (2 * Math.atan((Math.PI * activeCamera.fov) / 360));
    //             const fitWidthDistance = fitHeightDistance / activeCamera.aspect;
    //             safeDistance = fitOffset * Math.max(fitHeightDistance, fitWidthDistance);
    //         } else {
    //             safeDistance = maxSize * fitOffset;
    //             activeCamera.zoom = activeCamera.zoom / fitOffset;
    //             activeCamera.updateProjectionMatrix();
    //         }
    //     }

    //     // Compute camera position based on direction vector
    //     const newPosition = lookAtTarget.clone().addScaledVector(
    //         directionVector.clone().normalize(),
    //         safeDistance
    //     );
    //     console.log("New camera position:", newPosition);

    //     // Choose correct camera and update it
    //     const isPerspective = cameraWrapper.projection.current === "Perspective";
    //     const activeCamera = isPerspective ? cameraWrapper.threePersp : cameraWrapper.threeOrtho;

    //     activeCamera.position.copy(newPosition);
    //     activeCamera.near = Math.max(0.01, safeDistance * 0.01);
    //     activeCamera.far = Math.max(activeCamera.near + 0.1, safeDistance * 10);
    //     activeCamera.updateProjectionMatrix();

    //     // Apply look-at using OrbitControls
    //     if (controls?.setLookAt) {
    //         controls.setLookAt(
    //             newPosition.x, newPosition.y, newPosition.z,
    //             lookAtTarget.x, lookAtTarget.y, lookAtTarget.z,
    //             true // smooth transition
    //         );
    //     } else if (controls?.target) {
    //         controls.target.copy(lookAtTarget);
    //         controls.update?.();
    //     }

    //     // Optional: log final camera parameters
    //     console.log("Snap complete. Camera near/far:", activeCamera.near, activeCamera.far);
    // }




    static fitOrthoPerCameraToCenteredObject(cameraWrapper, object,  fitOffset = 1.2) 
    {
        //console.log("Starting camera fit...");
        //console.log(object)
        const controls = cameraWrapper.controls;
        const boundingBox = new THREE.Box3();
        boundingBox.makeEmpty();
        boundingBox.expandByObject(object);
        

        //console.log(boundingBox);

        const size = new THREE.Vector3();
        boundingBox.getSize(size);
        const center = new THREE.Vector3();
        boundingBox.getCenter(center);


        
       // console.log("Bounding box size:", size);
        //console.log("Bounding box center:", center);

        // Get the active three.js camera based on projection mode
        const isPerspective = cameraWrapper.projection.current === "Perspective";
        const activeCamera = isPerspective ? cameraWrapper.threePersp : cameraWrapper.threeOrtho;

        // Calculate maximum dimension
        const maxSize = Math.max(size.x, size.y, size.z);
        const fitHeightDistance = maxSize / (2 * Math.atan((Math.PI * activeCamera.fov) / 360));
        const fitWidthDistance = fitHeightDistance / activeCamera.aspect;
        const distance = fitOffset * Math.max(fitHeightDistance, fitWidthDistance);

        // Calculate direction and final camera position
        const direction = new THREE.Vector3();
        activeCamera.getWorldDirection(direction);
        direction.normalize().negate(); // move backwards from target
        const newPosition = new THREE.Vector3().copy(center).addScaledVector(direction, distance);

        //console.log("Fit distance:", distance);
        //console.log("Direction vector:", direction);
        //console.log("New camera position:", newPosition);

        // Update camera position
        activeCamera.position.copy(newPosition);
        activeCamera.near = Math.max(0.01, distance * 0.01);
        activeCamera.far = Math.max(activeCamera.near + 0.1, distance * 100);
        activeCamera.updateProjectionMatrix();

        // Update controls
        if (controls?.setLookAt) {
            controls.setLookAt(
            newPosition.x, newPosition.y, newPosition.z,
            center.x, center.y, center.z,
            true // smooth transition
            );
        } else if (controls?.target) {
            controls.target.copy(center);
            controls.update?.();
        }

        //console.log("Camera fit complete");
        }


}

export async function asyncFitOrthoPerCameraToCenteredObject(cameraWrapper, object,  fitOffset = 1.2) 
    {

        //console.log(cameraWrapper);
        //console.log("Starting camera fit...");
        const controls = cameraWrapper.controls;
        const boundingBox = new THREE.Box3();
        boundingBox.makeEmpty();
        boundingBox.expandByObject(object);
        //console.log(object)

        //console.log(boundingBox);

        const size = new THREE.Vector3();
        boundingBox.getSize(size);
        const center = new THREE.Vector3();
        boundingBox.getCenter(center);


        
        //console.log("Bounding box size:", size);
        //console.log("Bounding box center:", center);

        // Get the active three.js camera based on projection mode
        const isPerspective = cameraWrapper.projection.current === "Perspective";
        const activeCamera = isPerspective ? cameraWrapper.threePersp : cameraWrapper.threeOrtho;

        // Calculate maximum dimension
        const maxSize = Math.max(size.x, size.y, size.z);
        const fitHeightDistance = maxSize / (2 * Math.atan((Math.PI * activeCamera.fov) / 360));
        const fitWidthDistance = fitHeightDistance / activeCamera.aspect;
        const distance = fitOffset * Math.max(fitHeightDistance, fitWidthDistance);

        // Calculate direction and final camera position
        const direction = new THREE.Vector3();
        activeCamera.getWorldDirection(direction);
        direction.normalize().negate(); // move backwards from target
        const newPosition = new THREE.Vector3().copy(center).addScaledVector(direction, distance);

        //console.log("Fit distance:", distance);
        //console.log("Direction vector:", direction);
        //console.log("New camera position:", newPosition);

        // Update camera position
        activeCamera.position.copy(newPosition);
        activeCamera.near = Math.max(0.01, distance * 0.01);
        activeCamera.far = Math.max(activeCamera.near + 0.1, distance * 100);
        activeCamera.updateProjectionMatrix();

        // Update controls
        if (controls?.setLookAt) {
            controls.setLookAt(
            newPosition.x, newPosition.y, newPosition.z,
            center.x, center.y, center.z,
            true // smooth transition
            );
        } else if (controls?.target) {
            controls.target.copy(center);
            controls.update?.();
        }

        //console.log("Camera fit complete");
        }



export default ThreeJSFunctions;